import { Operation } from '../../../__generated__/globalTypes'

import {
  AccountFragment,
  accountFragmentString,
} from '../../fragments/__generated__/AccountFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { sponsorFragmentString } from '../../fragments/__generated__/SponsorFragment'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import getAccountRawString from '../GetAccount.graphql'

const getAccountString = [
  getAccountRawString,
  accountFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  stripeSubscriptionString,
  sponsorFragmentString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  userSettingsFragmentString,
].join('\n\n')

export type GetAccountData = {
  account: AccountFragment
}

export type GetAccount = Operation<GetAccountData>

export const GetAccount = (): GetAccount => ({
  query: getAccountString,
  variables: undefined,
})
